export default "__VITE_ASSET__DBRI3uCA__"